import { Component } from "react";
import { Switch, Route, Redirect, HashRouter } from "react-router-dom";
import "./App.css";
import Midas from "./Midas/Midas";
import { PostData } from "./Services/PostData";
import ProtectedRoute from "./Componants/protectedRoute";
import OctoForces from "./OctoForces/OctoForces";
import Header from "./Header/Header";
import HomePage from "./HomePage/HomePage";
import Links from "./Links/Links";
import Aris from "./Aris/Aris";
import Octopus from "./Octopus/Octopus";
import LW from "./LW/LW";
import Login from "./Login/Login";
import Sparks from "./Componants/Sparks/Sparks";
import Secrets from "./Componants/Secrets";
import BookOfChickens from "./BookOfChickens/BookOfChickens";

class App extends Component {
    constructor() {
        super();

        this.state = {
            version: require("../package.json").version,
            errorMessage: "",
            isAuthenticated: false,
            loginError: false,
            username: "",
        };

        this.handleOnChange = this.handleOnChange.bind(this);
        this.login = this.login.bind(this);
        this.logOut = this.logOut.bind(this);
    }

    componentDidMount() {
        const app = this;
        fetch("./authenticate.php")
            .then((response) => {
                return response.text();
            })
            .then((data) => JSON.parse(data))
            .then(function (data) {
                if (data.user_id) {
                    app.setState({
                        isAuthenticated: true,
                        username: data.user_name,
                    });
                }
            })
            .catch((er) => {
                //yo its cool, just catching so no red in console
            });
    }

    handleOnChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    login(event, email, password) {
        event.preventDefault();
        if (email && password) {
            PostData("login", { email, password }).then((result) => {
                let responseJson = result;

                console.log(result);

                console.log(`user is ${result.user}`);
                if (responseJson.user) {
                    sessionStorage.setItem("userData", JSON.stringify(responseJson));
                    this.setState({
                        isAuthenticated: true,
                        username: responseJson.user,
                    });
                } else {
                    console.log("error");
                    this.setState({
                        errorMessage: "Username or Password is incorrect",
                        loginError: true,
                    });
                }
            });
        }
    }

    logOut() {
        this.setState({
            isAuthenticated: false,
            username: "",
        });

        fetch("./logout.php").then((response) => {
            console.log(response);
        });
    }

    render() {
        return (
            <HashRouter>
                <div className="App">
                    {this.state.isAuthenticated && <Header logOut={this.logOut} version={this.state.version} />}
                    <Switch>
                        {/* Unprotected Routes to allow public access */}
                        <Route
                            exact
                            path="/login"
                            render={(props) =>
                                this.state.isAuthenticated ? (
                                    <Redirect to="/" />
                                ) : (
                                    <Login
                                        {...props}
                                        login={this.login}
                                        version={this.state.version}
                                        errorMessage={this.state.errorMessage}
                                        authenticated={this.state.isAuthenticated}
                                    />
                                )
                            }
                        />
                        {/* No authentication limits options on launcher pages */}
                        <Route
                            exact
                            path="/lw"
                            render={(props) => <LW {...props} authenticated={this.state.isAuthenticated} />}
                        />
                        <Route
                            exact
                            path="/aris"
                            render={(props) => <Aris {...props} authenticated={this.state.isAuthenticated} />}
                        />
                        {/* <Route
                            exact
                            path="/bookofchickens"
                            render={(props) => <BookOfChickens {...props} />}
                        /> */}
                        {/* Protected routes always re-direct to login */}
                        <ProtectedRoute
                            exact
                            path="/"
                            isAuthenticated={this.state.isAuthenticated}
                            component={HomePage}
                        />
                        <ProtectedRoute
                            exact
                            path="/octopus"
                            isAuthenticated={this.state.isAuthenticated}
                            render={(props) => <Octopus {...props} userName={this.state.username} />}
                        />
                        <ProtectedRoute
                            exact
                            path="/octoForces"
                            isAuthenticated={this.state.isAuthenticated}
                            component={OctoForces}
                        />
                        <ProtectedRoute
                            exact
                            path="/octoForces/:game"
                            isAuthenticated={this.state.isAuthenticated}
                            component={OctoForces}
                        />
                        <ProtectedRoute
                            exact
                            path="/midas"
                            isAuthenticated={this.state.isAuthenticated}
                            component={Midas}
                        />
                        <ProtectedRoute
                            exact
                            path="/links"
                            isAuthenticated={this.state.isAuthenticated}
                            component={Links}
                        />

                        {/* Re-directs any other urls to '/' */}
                        <Route render={() => <Redirect to="/" />} />
                    </Switch>
                    <Sparks />
                    <Secrets />
                </div>
            </HashRouter>
        );
    }
}

export default App;